// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LDRR","clinicsSelect":"styles_clinicsSelect__2o0k5"};